export function encryptToken(str, salt) {
  return btoa(encodeURIComponent(salt + str.trim()));
}

export function reachGoal(goalName, retry = 5) {
	const metrikaId = process.env?.VUE_APP_METRIKA ?? 103285269
	if (window?.ym && typeof window.ym === 'function') {
		window.ym(metrikaId, 'reachGoal', goalName);
		console.log('reachGoal:', goalName);
	} else if (retry > 0) {
		setTimeout(() => reachGoal(goalName, retry - 1), 500);
	}
}

export function domainName() {
	return window.location.hostname
}

export function getHost() {
	return process.env?.VUE_APP_HOST ?? window.location.origin
}

export async function sendVisit(account_id, dreams_ref) {
	try {
		// let url = import.meta.env.VUE_APP_API_URL + '/visit'
		let url = getHost() + '/visit'

		let body = {
			account_id: account_id,
			ref: dreams_ref,
			forms: 1,
		}

		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		return await response.json();
	} catch (e) {
		return false;
	}
}

export function decryptToken(token, salt) {
  const decoded = decodeURIComponent(atob(token));
  if (decoded.startsWith(salt)) {
    return decoded.slice(salt.length);
  }
  return null;
}

export function redirect(backuri_, token, router_, store_) {
	let url
	if (/^https?:\/\//.test(backuri_)) {
		url = new URL(backuri_)
	} else {
		url = new URL(backuri_, window.location.origin)
	}

	const params = Object.fromEntries(url.searchParams.entries())
	if (token) params.token = encryptToken(token, 'vidu.my')
	url.search = new URLSearchParams(params).toString()

	store_.deleteP('backuri')
	if (/^https?:\/\//.test(backuri_)) {
		// console.log(url.toString())
		window.location.href = url.toString()
	} else {
		return router_.push(url.pathname)
	}
}

export function validateNumberParam(paramName) {
  return (route) => {
    const value = Number(route.params[paramName]);
    if (isNaN(value)) {
      console.error(`Invalid parameter: ${paramName} must be a number.`);
      return { [paramName]: null }; // Return null for invalid numbers
    }
    return { [paramName]: value }; // Return the validated number
  };
}



export function formatPhone(digits) {
	if(digits === "+") return digits

	let formatted = '';
	let cleaned = digits.replace(/\D/g, '');
	if(cleaned)
	if (cleaned.length > 0) {
		if(cleaned[0] === '8') cleaned = '7' + cleaned.substring(1, 11);
		if(cleaned[0] !== '7') cleaned = '7' + cleaned;
		if (cleaned.length > 11) cleaned = cleaned.substring(0, 11);
	}


	let len = cleaned.length
	if ( len > 0) {
		formatted = '+7';
		if (len > 1) formatted += ' (' + cleaned.substring(1, 4);
		if (len > 4) formatted += ') ' + cleaned.substring(4, 7);
		if (len > 7) formatted += '-' + cleaned.substring(7, 9);
		if (len > 9) formatted += '-' + cleaned.substring(9, 11);
	}

	return formatted
}

export function isDebug() {
	return localStorage.getItem('vidu_debug')
}
